<div class="main">
  <div class="header">
    <span>{{parentData.heading}}</span>  <span style="margin-left: 3%;border-left: dashed 1px #fff;padding-left: 1%;"> {{'deadlineModal.total' | translate}}: {{parentData.count}}</span>
    <i class="material-icons" (click)="closeModal();">clear</i>
    <!-- <i *ngIf="parentData.type==1" class="material-icons dashIcon" (click)="openDashboard($event, 'live', 'acceptance')">launch</i> -->
   <!--  <i *ngIf="parentData.type==2" class="material-icons dashIcon" (click)="openDashboard($event, 'live', 'assignment')">launch</i> -->
  </div>
  <div class="section">

    <div class="body">

      <div class="cardSection" *ngIf="parentData.type == 0">
        <div class="cards" *ngFor="let item of acceptanceDeadline; let i = index;">
          <div class="cardHeader">
            <div class="headerRow">{{'deadlineModal.order' | translate}}: {{item.OIN}} </div>
            <!-- <div class="headerRow"> Pending Allocation </div> -->
            <div class="headerRow"> {{'deadlineModal.totalPending' | translate}}: {{item.to_be_accepted || 'N/A'}} </div>
          </div>
          <div class="cardBody diff" *ngFor="let element of item.allocations; let ind = index;">
            <div class="cardRow">
              <span style="font-size: 10px; display: none;">{{ind + 1}}.</span> {{element.shipper.parent_name || 'N/A'}} - {{element.shipper.name || 'N/A'}}
            </div>
            <div class="cardRow">
              {{element.allocated}}
            </div>
            <div class="cardRow">
              <span *ngIf="getDuration(element.acceptance_deadline)">{{'deadlineModal.expiresIn' | translate}}: {{getDuration(element.acceptance_deadline)}}</span>
              <span *ngIf="!getDuration(element.acceptance_deadline)">{{'deadlineModal.expired' | translate}}</span>
              <br>
              <span style="font-size: 9px;">{{'deadlineModal.deadline' | translate}}: {{getDate(element.acceptance_deadline)}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="cardSection" *ngIf="parentData.type == 1">
        <div class="cards" *ngFor="let item of assignmentDeadline; let i = index;">
          <div class="cardHeader">
            <div class="headerRow">{{'deadlineModal.order' | translate}}: {{item.OIN}} </div>
            <!-- <div class="headerRow"> Pending Allocation </div> -->
            <div class="headerRow"> {{'deadlineModal.totalPending' | translate}}: {{item.total_accepted - item.total_assigned}} </div>
          </div>
          <div class="cardBody diff" *ngFor="let element of item.allocations; let ind = index;">
            <div class="cardRow">
              <span style="font-size: 10px; display: none;">{{ind + 1}}.</span> {{element.shipper.parent_name}} - {{element.shipper.name}}
            </div>
            <div class="cardRow">
              {{element.accepted - element.assigned}}
            </div>
            <div class="cardRow">
              <span *ngIf="getDuration(element.assignment_deadline)">{{'deadlineModal.expiresIn' | translate}}: {{getDuration(element.assignment_deadline)}}</span>
              <span *ngIf="!getDuration(element.assignment_deadline)">{{'deadlineModal.expired' | translate}}</span>
              <br>
              <span style="font-size: 9px;">{{'deadlineModal.deadline' | translate}}: {{getDate(element.assignment_deadline)}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>